import React from 'react';
import './styles.css';

function Strip() {
  return (
    <section className="strip" id="supply">
      <div className="strip-copy scroll-reveal">
        <h2>Why teams switch to FR</h2>
        <p>
          We orchestrate procurement, QA, and last-mile delivery so buyers can focus on menus, not
          midnight calls.
        </p>
      </div>
      <div className="strip-grid">
        <article className="feature reveal">
          <h3>Smart auctions</h3>
          <p>
            Real-time bidding across verified landing centers keeps pricing fair and supply steady.
          </p>
        </article>
        <article className="feature reveal">
          <h3>Cold chain control</h3>
          <p>
            IoT sensors track temperature throughout the supply chain—from vessel to distribution
            facility—with automated escalation for any deviations.
          </p>
        </article>
        <article className="feature reveal">
          <h3>Guaranteed yield</h3>
          <p>Automated grading and prep ensure portion consistency with less waste.</p>
        </article>
      </div>
    </section>
  );
}

export default Strip;
